// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__2FCE1","row":"styles_row__1DKwc","button":"styles_button__3xojm","box":"styles_box__Ac8qt","dropdown":"styles_dropdown__1tiDZ"};